import { render, staticRenderFns } from "./back-arrow.vue?vue&type=template&id=1a5f598e&scoped=true"
import script from "./back-arrow.vue?vue&type=script&setup=true&lang=js"
export * from "./back-arrow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./back-arrow.vue?vue&type=style&index=0&id=1a5f598e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f598e",
  null
  
)

export default component.exports